import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import Table from "@/common/elements/Table";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import CustomModal from "../CustomModal";
import Personal, { PERSON } from "../InmateDetails/Personal";
import { Form, message, notification } from "antd";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import useDialog from "@/hooks/useDialog";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { MODULES_LIST_WITH_ID, SUB_MODULES_LIST_WITH_ID } from "@/util/common_variable";

const BailPaymentDetailForm = ({
  bookingBails,
  singleBookingPayments,
  paymentForm,
  setSingleBookingPayments,
  chargesData,
}) => {
  const { showDialog } = useDialog();
  const { bookingsFieldsEnabled } = useSelector((state) => state?.bookings);
  const [paymentFormState, setPaymentFormState] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [paymentTypeConfirmModal, setPaymentTypeConfirmModal] = useState(null);
  const [modalForm] = Form.useForm();
  const [isPaymentCoversModal, setIsPaymentCoversModal] = useState(false);
  const [selectBailDetail, setSelectBailDetail] = useState(null);
  const [bailrecords, setBailRecords] = useState([]);
  const fullSearch = useSelector(state => state.fullSearch);
  const paymentTypeID = Form.useWatch("paymentTypeID", paymentForm);
  console.log(paymentTypeID);

  useEffect(() => {
    if (isNonEmptyVariable(singleBookingPayments)) {
      const paidDateTime = dayjs(
        `${isNonEmptyVariable(singleBookingPayments?.datePaid)
          ? singleBookingPayments?.datePaid
          : ""
        } ${isNonEmptyVariable(singleBookingPayments?.timePaid)
          ? singleBookingPayments?.timePaid
          : ""
        }`
      );
      let br = [];
      if (singleBookingPayments?.bookingBailPaymentBails) {
        br = singleBookingPayments?.bookingBailPaymentBails?.map((b) => {
          return {
            ...b,
            bailType: getRefListNameByID("BondType", b?.bailTypeID) || null,
            charge: getRefListNameByID("Charges", b?.charge) || null,
          };
        });

        const paymentAmount =
          singleBookingPayments?.bookingBailPaymentBails?.reduce((acc, b) => {
            return (acc += parseFloat(b?.bailAmount));
          }, 0);

        paymentForm.setFieldValue("paymentAmount", paymentAmount);
      }

      setBailRecords(() => br);
      setPaymentFormState(() => ({
        ...singleBookingPayments,
        paymentPaidDateTime: paidDateTime?.isValid() ? paidDateTime : "",
      }));
    } else {
      setPaymentFormState(null);
    }
  }, [singleBookingPayments]);

  useEffect(() => {
    if (isNonEmptyVariable(paymentFormState)) {
      paymentForm.setFieldsValue(paymentFormState);
    } else {
      paymentForm.resetFields();
      if(!fullSearch) {
        paymentForm?.setFieldValue("paymentPaidDateTime", dayjs());
      }
    }
  }, [paymentFormState]);

  const handlePaymentModalVisible = () => {
    setIsPaymentCoversModal(!isPaymentCoversModal);
  };

  const cancelAction = () => {
    setSelectBailDetail(null);
    setIsPaymentCoversModal(() => false);
  };

  const onRowClick = (v) => {
    setSelectBailDetail(v);
  };

  const deleteAction = () => {
    console.log(singleBookingPayments, selectBailDetail);

    if (singleBookingPayments?.bookingBailPaymentBails?.length) {
      const bookingBailPaymentBails =
        singleBookingPayments?.bookingBailPaymentBails?.filter(
          (b) =>
            (isNonEmptyVariable(b?.bookingBailID) &&
              b?.bookingBailID !== selectBailDetail?.bookingBailID) ||
            b?.bookingBailUuid !== selectBailDetail?.bookingBailUuid
        );
      setSingleBookingPayments(() => ({
        ...singleBookingPayments,
        bookingBailPaymentBails: bookingBailPaymentBails,
      }));
    }
  };

  const onModalSaveClick = () => {
    modalForm?.validateFields().then((m) => {
      let bookingBailPaymentBails = [];
      console.log(m);

      const bookingBail = bookingBails?.find(
        (bb) => bb?.value === m?.bookingBailUuid
      )?.data;

      console.log(singleBookingPayments);
      console.log(
        singleBookingPayments?.bookingBailPaymentBails?.findIndex(
          (bp) =>
            bp?.bookingBailID === m?.bookingBailUuid ||
            bp?.bookingBailUuid === m?.bookingBailUuid
        )
      );

      if (
        isNonEmptyVariable(singleBookingPayments?.bookingBailPaymentBails) &&
        singleBookingPayments?.bookingBailPaymentBails?.findIndex(
          (bp) =>
            bp?.bookingBailID === m?.bookingBailUuid ||
            bp?.bookingBailUuid === m?.bookingBailUuid
        ) !== -1
      ) {
        showDialog("info", {
          title: "Duplicate Bail",
          content: "This bail already selected",
          confirmButtonText: "Ok",
        });
        modalForm.setFieldValue("bookingBailUuid", "");
        return;
      }

      if (singleBookingPayments?.bookingBailPaymentBails?.length) {
        bookingBailPaymentBails =
          singleBookingPayments?.bookingBailPaymentBails;
      }

      bookingBailPaymentBails.push(bookingBail);
      bookingBailPaymentBails = bookingBailPaymentBails?.map((bbp) => {
        let bailCharge = null;
        chargesData?.forEach((c) => {
          if (
            (isNonEmptyVariable(c?.bookingBails?.[0]?.bookingBailID) &&
              c?.bookingBails?.[0]?.bookingBailID === bbp?.bookingBailID) ||
            c?.bookingBails?.[0]?.bookingBailUuid === bbp?.bookingBailUuid
          ) {
            bailCharge = c;
          }
        });

        console.log("bailCharge", bailCharge);

        return {
          ...bbp,
          charge: bailCharge?.chargeDescriptionID || "",
          isPaymentBailAdd: true,
        };
      });

      setSingleBookingPayments(() => ({
        ...singleBookingPayments,
        bookingBailPaymentBails: bookingBailPaymentBails,
      }));
      modalForm.setFieldValue("bookingBailUuid", "");
    });
    cancelAction();
  };

  const handlePaymentTypeChange = (type) => {
    setPaymentType(type);
    if (type !== 54820003) {
      setPaymentTypeConfirmModal(true);
    }
  };

  return (
    <>
      <StyledSectionHeading>
        <span>Payment Information</span>
      </StyledSectionHeading>
      <Form form={paymentForm} disabled={!bookingsFieldsEnabled}>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={5}>
            <FormItem
              name="paymentTypeID"
              label="Payment Type"
              rules={ !fullSearch ? [
                {
                  required: true,
                  message: "Payment type is required",
                },
              ] : []}
            >
              <Select
                onChange={handlePaymentTypeChange}
                options={getOptionsFromRefList(
                  "Payment_Type",
                  false,
                  false,
                  true
                )}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={4}>
            <FormItem name="paymentAmount" label="Amount">
              <TextField type="number" disabled={!fullSearch} />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem name="paymentPaidDateTime" label="Date/Time Paid">
              <CommonDatePicker
                format="MM/DD/YYYY HH:mm"
                placeholder="MM/DD/YYYY HH:mm"
                showTime={true}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem
              name="receiptNumber"
              label="Receipt #"
              rules={ !fullSearch ? 
                (paymentTypeID === 54820001 ||
                  paymentTypeID === 54820002 ||
                  paymentTypeID === 54820003
                  ? [
                    {
                      required: true,
                      message: "Receipt number is required",
                    },
                  ]
                  : []) : []
              }
            >
              <TextField type="number" />
            </FormItem>
          </StyledGridCol>
          {paymentTypeID === 54820002 && (
            <StyledGridCol lg={5}>
              <FormItem
                name="checkNumber"
                label="Check Number #"
                rules={ !fullSearch ? [
                  {
                    required: true,
                    message: "Check number is required",
                  },
                ] : []}
              >
                <TextField type="number" />
              </FormItem>
            </StyledGridCol>
          )}
          <FormItem name="comments" label="Comments">
            <TextField inputType="textarea" />
          </FormItem>
        </StyledGridRow>

        <StyledSectionHeading>
          <span>Bails This Payment Covers</span>
        </StyledSectionHeading>
        <StyledSubTableContainer>
          <StyledFlex justify="end" gap="10px" marginBottom="10px">
            <Button onClick={handlePaymentModalVisible} disabled={!(hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.subModule,
              LABELS_CAPITAL.ADD,
              MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
              SUB_MODULES_LIST_WITH_ID.Arrest_Report
            ))}>
              <PlusOutlined /> Add
            </Button>
            {<Button disabled={selectBailDetail === null || !(hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.subModule,
              LABELS_CAPITAL.DELETE,
              MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
              SUB_MODULES_LIST_WITH_ID.Arrest_Report
            ))} onClick={deleteAction}>
              Delete
            </Button>}
            <Button onClick={cancelAction} disabled={selectBailDetail === null}>
              Cancel
            </Button>
          </StyledFlex>

          <Table
            headers={[
              { key: "bailAmount", text: "Bail Amount" },
              { key: "bailType", text: "Bail Type" },
              { key: "charge", text: "Charge" },
            ]}
            data={bailrecords || []}
            onRowClick={onRowClick}
            selected={selectBailDetail === null}
          />
        </StyledSubTableContainer>

        {paymentType === 54820003 ? (
          <>
            <StyledSectionHeading marginTop="25px">
              <span>Bonding Information</span>
            </StyledSectionHeading>

            <StyledGridRow gutter={16}>
              <StyledGridCol xs={6}>
                <FormItem name="bondedBy" label="Bondsman Name">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={6}>
                <FormItem name="bondPhone" label="Phone">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol xs={6}>
                <FormItem name="bondCity" label="City">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={6}>
                <FormItem name="bondStateID" label="ST">
                  <Select
                    options={getOptionsFromRefList(
                      "USState",
                      false,
                      false,
                      true
                    )}
                    placeholder="ST"
                    showSearch={false}
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={6}>
                <FormItem name="bondZip" label="Zip Code">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={18}>
                <FormItem name="bondStreet1" label="Bond Address">
                  <TextField inputType="textarea" id="addressLineOne" />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </>
        ) : (
          <>
            <StyledSectionHeading marginTop="25px">
              <span>Personal Information</span>
            </StyledSectionHeading>
            {/* <Personal person={PERSON.BAILPAYMENT} /> */}
            <StyledGridRow gutter={16}>
              {/* First Name */}
              <StyledGridCol xs={6}>
                <FormItem name="firstName" label="First Name">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Middle Name */}
              <StyledGridCol xs={6}>
                <FormItem name="middleName" label="Middle Name">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Last Name */}
              <StyledGridCol xs={6}>
                <FormItem name="lastName" label="Last Name">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Suffix */}
              <StyledGridCol xs={6}>
                <FormItem name="suffix" label="Suffix">
                  <Select
                    options={[
                      { label: "Jr", value: "Jr" },
                      { label: "Sr", value: "Sr" },
                      { label: "II", value: "II" },
                      { label: "III", value: "III" },
                      { label: "IV", value: "IV" },
                    ]}
                    placeholder="Select Suffix"
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>

              {/* Age */}
              <StyledGridCol xs={6}>
                <FormItem name="age" label="Age">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Sex */}
              <StyledGridCol xs={6}>
                <FormItem name="sex" label="Sex">
                  <Select
                    options={[
                      { label: "Male", value: "Male" },
                      { label: "Female", value: "Female" },
                      { label: "Other", value: "Other" },
                    ]}
                    placeholder="Select Sex"
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>

              {/* Door No */}
              <StyledGridCol xs={6}>
                <FormItem name="doorNo" label="Door No">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Street 1 */}
              <StyledGridCol xs={6}>
                <FormItem name="street1" label="Street">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Street 2 */}
              <StyledGridCol xs={6}>
                <FormItem name="street2" label="Street 2">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* Apt Number */}
              <StyledGridCol xs={6}>
                <FormItem name="aptNumber" label="Apt Number">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* City */}
              <StyledGridCol xs={6}>
                <FormItem name="city" label="City">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              {/* State */}
              <StyledGridCol xs={6}>
                <FormItem name="stateID" label="State">
                  <Select
                    options={getOptionsFromRefList(
                      "USState",
                      false,
                      false,
                      true
                    )}
                    placeholder="State"
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>

              {/* Zip */}
              <StyledGridCol xs={6}>
                <FormItem name="zip" label="Zip Code">
                  <TextField />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </>
        )}

        <StyledSectionHeading>
          <span>Payment Administrative Information</span>
        </StyledSectionHeading>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={4}>
            <FormItem label="ID">
              <TextField />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="Date Entered">
              <TextField />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Time Entered">
              <TextField />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="User">
              <TextField />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>

      {isPaymentCoversModal && (
        <CustomModal
          size="md"
          header="Bail Payment Details"
          show={isPaymentCoversModal}
          onHide={handlePaymentModalVisible}
          onSaveClick={onModalSaveClick}
        >
          <Form
            form={modalForm}
            initialValue={{
              bookingBailUuid: "",
            }}
          >
            <FormItem
              name="bookingBailUuid"
              label="Select a bail that this payment is going to cover"
              rules={ !fullSearch ? [
                {
                  required: true,
                  message: "Field is required",
                },
              ] : []}
            >
              <Select options={bookingBails} />
            </FormItem>
          </Form>
        </CustomModal>
      )}

      {paymentTypeConfirmModal && (
        <CustomModal
          size="md"
          header=""
          submitButtonText="Okay"
          show={paymentTypeConfirmModal}
          onHide={() => setPaymentTypeConfirmModal(false)}
          onSaveClick={() => setPaymentTypeConfirmModal(false)}
        >
          <h4 style={{ color: "var(--text-black)", textAlign: "center" }}>
            Would you like to bring over the inmate's name and address?
          </h4>
        </CustomModal>
      )}
    </>
  );
};
export default BailPaymentDetailForm;
